<template>
  <v-container>
    <v-row justify="center" class="mt-2">
      <v-col cols="auto" class="d-flex flex-column align-center">
        <v-badge
          overlap
          color="white"
          :content="null"
          style="cursor: pointer"
          offset-x="20"
          @click.native="triggerFileInput"
        >
          <template v-slot:badge>
            <v-btn
              icon
              small
              color="primary"
              style="box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08); pointer-events: none"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <v-avatar width="72" v-if="employee.image_path">
            <v-img :src="conf.apiUrlBase + '/gallery/' + employee.image_path"></v-img>
          </v-avatar>
          <v-avatar width="72" height="72px" v-else>
            <v-icon size="72px">mdi-account-circle</v-icon>
          </v-avatar>
        </v-badge>
        <div class="mt-2 font-weight-medium" style="font-size: 1.1em">
          {{ toLatin(employee.name) }} {{ toLatin(employee.lastname) }}
        </div>
      </v-col>
    </v-row>

    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      style="display: none"
      @change="onFileChange"
    />
  </v-container>
</template>

<script>
export default {
  name: "EmployeeAvatarSection",
  props: {
    employee: Object,
    conf: Object,
  },
  emits: ["upload"],
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const file = event.target.files[0];
      // Reset so picking the same file again still fires @change
      event.target.value = "";
      if (file) {
        this.$emit("upload", file);
      }
    },
  },
};
</script>
